import React from 'react';
import SingleInstanceForm from './SingleInstanceForm';
import MultiInstancesForm from './MultiInstancesForm';
import DisplayOnlyBlock from './DisplayOnlyBlock';
import ParkingBlockForm from './ParkingBlockForm/ParkingBlockForm';

const BlockForm = ({ cotenant, application, block, form }) => {
  const {
    title,
    description,
    form_type,
    min_instances,
    max_instances,
    fields,
    responses,
    values = [],
    image_url,
    image_alt,
    image_caption,
    image_href,
    has_rendering_question,
    rendering_question,
    rendering_question_response,
  } = block;

  const activeFields = fields?.filter((field) => field.active);
  // Initial values can come from 3 sources:
  // 1. The current edited values in the form
  // 2. The previous submitted responses of the whole wizard
  // 3. The cotenant saved details (only for the lead applicant details block)
  // We will render them in that order of priority
  const getSingleInstanceFormInitialValues = (values, responses = [], cotenant) => {
    responses = responses[0] ?? {};
    const currentFormValues = values[0]?.reduce((acc, { attribute }) => {
      return { ...acc, ...attribute };
    }, {});

    return { ...cotenant, ...responses, ...currentFormValues };
  };

  const getMultiInstanceFormInitialValues = (values, responses = []) => {
    if (values.length) {
      return values.map((value) => {
        return value.reduce((acc, { attribute }) => {
          return { ...acc, ...attribute };
        }, {});
      });
    } else {
      return responses;
    }
  };

  if (form_type === 'single_instance_form') {
    return (
      <SingleInstanceForm
        form={form}
        fields={activeFields}
        formTitle={title}
        formDescription={description}
        initialValues={getSingleInstanceFormInitialValues(values, responses, cotenant)}
        hasRenderingQuestion={has_rendering_question}
        renderingQuestion={rendering_question}
      />
    );
  } else if (form_type === 'display_only') {
    return (
      <DisplayOnlyBlock
        title={title}
        description={description}
        imageUrl={image_url}
        imageAlt={image_alt}
        imageCaption={image_caption}
        imageHref={image_href}
      />
    );
  } else if (form_type === 'custom_parking') {
    return (
      <ParkingBlockForm
        formTitle={title}
        formDescription={description}
        formMinInstances={min_instances}
        formMaxInstances={max_instances}
        fields={activeFields}
        application={application}
        cotenant={cotenant}
      />
    );
  } else {
    return (
      <MultiInstancesForm
        form={form}
        formTitle={title}
        formDescription={description}
        formMinInstances={min_instances}
        formMaxInstances={max_instances}
        hasRenderingQuestion={has_rendering_question}
        renderingQuestion={rendering_question}
        renderingQuestionResponse={rendering_question_response}
        fields={activeFields}
        items={getMultiInstanceFormInitialValues(values, responses)}
      />
    );
  }
};

export default BlockForm;
